import React, { useEffect } from "react";
import { Table, Tooltip } from "antd";
import { ColumnsType } from "antd/es/table";
import { useAppointmentModel } from "../appointmentModel";
import { IAppointmentDetail } from "../appointmentTypes";
import { useDictModel } from "@/views/base/dict/dictModel";
import YhTag from "@/components/YhTag";
import useGlobalModel from "@/model/globalModel";
import zh_CN from "@/locale/zh-CN";
import en_US from "@/locale/en-US";



type statusType = {
    "appointment.transfer": string,
    "appointment.change": string,
    "appointment.create": string,
    [key: string]: any
}

export function DataTable() {

    let LanguageArr: any = {
        "zh-CN": zh_CN,
        "en-US": en_US
    }
    const { language, rolesAllList, setLocale } = useGlobalModel();
    const Locale = setLocale(LanguageArr)

    const {
        dataSource, selectedRowKeys, pgCfg, descRows,
        loadData, setSelectedRowKeys, setDescRows
    } = useAppointmentModel();

    const { getTreeSelectOne, getSelectedDictOne, getTreeNodeName, getTreeNodeOne } = useDictModel();

    const statusColor: statusType = {
        "appointment.create": "blue",
        "appointment.transfer": "cyan",
        "appointment.change": "red",
    }
    const columns: ColumnsType<IAppointmentDetail> = [
        {
            // title: 序号,
            title: Locale['SN'],
            width: 80,
            fixed: "left",
            render: (t, r, i) => i + 1
        }, {
            // title: '预约单号',
            title: Locale['Appointment Doc No.'],
            width: 180,
            dataIndex: 'appointmentCode',
            fixed: "left",
        }, {
            // title: '单据状态',
            title: Locale['Status'],
            width: 120,
            dataIndex: 'status',
            render: (text) => <YhTag color={statusColor[text]} text={language == "zh-CN" ? getTreeNodeOne(text)[0].name : getTreeNodeOne(text)[0].nameEn as string} />,
            // render:(text)=>getTreeNodeOne(text)
        }, {
            // title: '单据日期',
            title: Locale['Creation Time'],
            width: 160,
            dataIndex: 'createTime',
            render: (text: any) => <Tooltip placement="topLeft" title={text}><p className="ellipsis">{text}</p></Tooltip>,
        }, {
            // title: '客户名称',
            title: Locale['Customer'],
            width: 160,
            dataIndex: 'customerName',
            render: (text: any) => <Tooltip placement="topLeft" title={text}><p className="ellipsis">{text}</p></Tooltip>,
        }, {
            // title: '车辆牌照',
            title: Locale['License Plate'],
            width: 160,
            dataIndex: 'licensePlate',
        }, {
            // title: 'VIN码',
            title: Locale['VIN'],
            width: 160,
            dataIndex: 'vin',
        }, {
            // title: '联系人',
            title: Locale['Contact'],
            width: 120,
            dataIndex: 'contact',
        }, {
            // title: '联系电话',
            title: Locale['Contact Number'],
            width: 160,
            dataIndex: 'phone',
        }, {
            // title: '维修类型',
            title: Locale['ServiceType'],
            width: 160,
            dataIndex: 'serviceTypeCode',
            // render: (text) => getTreeNodeName(text)
            render: (text) => {
                if (text) {
                    return language == "zh-CN" ? getTreeNodeOne(text)[0]?.name : getTreeNodeOne(text)[0]?.nameEn as string
                } else {
                    return ""
                }
            }
        }, {
            // title: '预计工时',
            title: Locale['Estimated Man-hours'],
            width: 160,
            dataIndex: 'workHour',
        }, {
            // title: '预计工时费',
            title: Locale['Estimated Labor Cost'],
            width: 160,
            dataIndex: 'workingHoursAmount',
        }, {
            // title: '预计材料费',
            title: Locale['Estimated Material Cost'],
            width: 160,
            dataIndex: 'materialScienceAmount',
        }, {
            // title: '费用合计',
            title: Locale['Total Amount'],
            width: 160,
            dataIndex: 'receivableTotalAmount',
            render: (text, record: any) => (Number(text) * (Number(record.taxRate))).toFixed(2)
        }, {
            // title: '预约进厂时间',
            title: Locale['Appointed Enter Time'],
            width: 160,
            ellipsis: true,
            dataIndex: 'enterTime',
        }, {
            // title: '预约出厂时间',
            title: Locale['Appointed Delivery Time'],
            width: 180,
            ellipsis: true,
            dataIndex: 'deliveryTime',
        }, {
            // title: '制单员',
            title: Locale['Creator'],
            width: 180,
            dataIndex: 'createUser',
        }, {
            // title: '预约技师',
            title: Locale['Appointed Technicians'],
            width: 160,
            // dataIndex: 'technicianNames',
            render: (text, record) => {
                let technicianNames: string[] = []
                record.itemDetails?.forEach((el, index) => {
                    technicianNames = [...technicianNames, ...el?.technicianName.split(',') ?? []]
                })
                return Array.from(new Set(technicianNames)).toString();
            }
        }, {
            // title: '失约原因',
            title: Locale['Cancel Reason'],
            width: 160,
            dataIndex: 'cancelReason',
        }, {
            title: '备注',
            width: 160,
            dataIndex: 'note',
        },
    ];
    useEffect(() => {
        loadData().then();
    }, [])

    //点击行选高亮
    const onRow = (record: IAppointmentDetail) => {


        // let findIndex = selectedRowKeys.indexOf(id);
        // let newSelectedRowKeys = [...selectedRowKeys];
        // if (findIndex === -1) {
        //     newSelectedRowKeys.push(id);
        //     setSelectedRowKeys(newSelectedRowKeys);
        // } else {
        //     newSelectedRowKeys.splice(findIndex, 1);
        //     setSelectedRowKeys(newSelectedRowKeys);
        // }
        let { id } = record as { id: string }
        let findIndexDesc = descRows.findIndex((item) => (item.id === id))
        let newDescRows = [...descRows];
        let newSelectedRowKeys = [...selectedRowKeys];

        if (findIndexDesc === -1) {
            //统计数据
            newDescRows.push(record)
            setDescRows(newDescRows)
            //表格选中行Key值
            newSelectedRowKeys.push(id);
            setSelectedRowKeys(newSelectedRowKeys);
        } else {
            //统计数据
            newDescRows.splice(findIndexDesc, 1);
            setDescRows(newDescRows);
            //表格选中行Key值
            newSelectedRowKeys.splice(findIndexDesc, 1);
            setSelectedRowKeys(newSelectedRowKeys);
        }
    };

    return (
        <Table
            style={{ cursor: "pointer" }}
            rowKey={record => record.id as string}
            rowSelection={{
                // type: "radio",
                onChange: (selectedRowKeys: React.Key[], selectedRows: IAppointmentDetail[]) => {
                    console.log(selectedRows)
                    setSelectedRowKeys(selectedRowKeys as string[]);
                    setDescRows(selectedRows)
                },
                selectedRowKeys
            }}
            columns={columns}
            dataSource={dataSource}
            pagination={{
                ...pgCfg,
                position: ["bottomCenter"],
                showTotal: () => `共${pgCfg.total}条`,
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize }).then();
                }
            }}
            onRow={record => ({
                onClick: () => onRow(record)
            })}
            scroll={{ x: 'max-content', y: 460 }}
        />
    )
}
